import styled from 'styled-components';
import IconWrapper from '../../../IconWrapper';

const StyledUnlinkBudgetButton = styled(IconWrapper)`
  &:hover {
    cursor: pointer;

    svg {
      path, circle, rect, polygon, line, polyline {
        stroke: ${props => props.theme.colors.primary_6};
      }
    }
  }
`;

const StyledUnlinkBudgetButtonModalIconWrapper = styled(IconWrapper)`
  svg {
    path, circle, rect, polygon, line, polyline {
      fill: none !important;
    }
  }
`;

export {
  StyledUnlinkBudgetButton,
  StyledUnlinkBudgetButtonModalIconWrapper,
}
